import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { reactivateManaged } from 'store/modules/management_store/actions';
import { ManagementState } from 'store/modules/management_store/types';

interface ModalReactivateManagementProps {
  modalReactivateManagementOpened: boolean;
  setModalReactivateManagementOpened: React.Dispatch<React.SetStateAction<boolean>>;
  biddingId: number;
}

const ModalReactivateManagement = (props: ModalReactivateManagementProps) => {
  const { modalReactivateManagementOpened, setModalReactivateManagementOpened, biddingId } = props;

  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);

  const dispatch = useDispatch();

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const SHORT_DELAY = 2000;

  useEffect(() => {
    if (!request.reactivate_managed.loaded) return;

    setShowSuccess(true);
  }, [request.reactivate_managed.loaded]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowSuccess(false);
      setModalReactivateManagementOpened(false);
    }, SHORT_DELAY);
  }, [showSuccess]);

  useEffect(() => {
    if (!request.reactivate_managed.error) return;

    setShowError(true);
  }, [request.reactivate_managed.error]);

  useEffect(() => {
    if (!showError) return;

    setTimeout(() => {
      setShowError(false);
    }, SHORT_DELAY);
  }, [showError]);

  return (
    <Modal show={modalReactivateManagementOpened} size="sm">
      <div className="modal-header">
        <h6 className="modal-title" id="modalLabel">
          Aviso
        </h6>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => {
            setModalReactivateManagementOpened(!modalReactivateManagementOpened);
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        {showError && (
          <div className="my-2 alert alert-danger text-center">
            <button
              type="button"
              id="close-alert"
              className="close"
              onClick={() => setShowError(false)}
            >
              ×
            </button>
            Erro ao reativar licitação.
          </div>
        )}
        {showSuccess && (
          <div className="my-2 alert alert-success text-center p-2 d-flex align-items-center">
            Licitação reativada com sucesso!
            <button
              type="button"
              id="close-alert"
              className="ml-2 close"
              onClick={() => setShowSuccess(false)}
            >
              ×
            </button>
          </div>
        )}
        <p className="mb-0">
          Ao reativar o gerenciamento desta licitação os dados referentes à finalização serão
          excluídos. Deseja continuar?
        </p>
      </div>
      <div className="modal-footer d-flex justify-content-around">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setModalReactivateManagementOpened(!modalReactivateManagementOpened)}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => dispatch(reactivateManaged(biddingId || 0))}
        >
          Continuar
        </button>
      </div>
    </Modal>
  );
};

export default ModalReactivateManagement;
